export const  tmEndpoints = {
    generalTemplates: {
        list: {
            api: '/api/generaltemplates',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/generaltemplates/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/generaltemplates/create',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/generaltemplates/update',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/api/generaltemplates/delete',
            method: 'POST',
            parameter: true
        }
    },
    email: {
        list: {
            api: '/api/emails',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/emails/details',
            method: 'GET',
            parameter: true
        },
        retry: {
            api: '/api/emails/retry',
            method: 'POST',
            parameter: true
        },
        forward: {
            api: '/api/emails/forward',
            method: 'POST',
            parameter: true
        },
        send: {
            api: '/api/emails',
            method: 'POST',
            parameter: false
        },
        emailPreview: {
            api: '/api/emails/preview',
            method: 'POST',
            parameter: false
        },
    },
    notification: {
        list: {
            api: '/api/mercury/notifications/list',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/mercury/notifications/details',
            method: 'GET',
            parameter: true
        }
    },
    emailTemplate: {
        add: {
            api: '/api/templates',
            method: 'POST',
            parameter: false
        },
        details: {
            api: '/api/templates/details',
            method: 'GET',
            parameter: true
        },
        import: {
            api: '/api/templates/import/env/create',
            method: 'POST',
            parameter: true
        },
        compare: {
            api: '/api/templates/compare/env',
            method: 'GET',
            parameter: false
        },
        byKey: {
            api: '/api/templates/key',
            method: 'GET',
            parameter: true
        },
        list: {
            api: '/api/templates',
            method: 'GET',
            parameter: false
        },
        delete: {
            api: '/api/templates/delete',
            method: 'POST',
            parameter: true
        },
        update: {
            api: '/api/templates/update',
            method: 'POST',
            parameter: true
        },
        test: {
            api: '/api/templates/test',
            method: 'POST',
            parameter: true
        },
        testNotification: {
            api: '/api/templates/testNotification',
            method: 'POST',
            parameter: true
        },
        retry: {
            api: '/api/templates/retry',
            method: 'POST',
            parameter: true
        }
    },
    emailLog: {
        list: {
            api: '/api/mercury/emailogs',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/mercury/emailogs/details',
            method: 'GET',
            parameter: true
        }
    },
    configuration:{
        list: {
            api: '/api/mercury/configurations',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/mercury/configurations/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/mercury/configurations/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/mercury/configurations/update',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/api/mercury/configurations/delete',
            method: 'POST',
            parameter: true
        },
        configurationType:{
            api: '/api/mercury/configurations/dictionary/types',
            method: 'GET',
            parameter: false
        },
        configurationGroup:{
            api: '/api/mercury/configurations/dictionary/groups',
            method: 'GET',
            parameter: false
        }
    },
    preference:{
        list: {
            api: '/api/mercury/preferences',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/mercury/preferences/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/mercury/preferences/create',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/mercury/preferences/update',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/api/mercury/preferences/delete',
            method: 'POST',
            parameter: true
        },
        configurationType:{
            api: '/api/mercury/preferences/dictionary/types',
            method: 'GET',
            parameter: false
        },
        configurationGroup:{
            api: '/api/mercury/preferences/dictionary/groups',
            method: 'GET',
            parameter: false
        },
        preferenceType: {
            api: '/api/mercury/preferences/dictionary/preferences',
            method: 'GET',
            parameter: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/tm.endpoints.ts